import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact-page">
      <div className="contact-hero-section">
        <div
          className="contact-background-image"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/barbmagecastle.png)` }}
        />
        <div className="contact-hero-content">
          <img src="/hugemajicrealmlogo.png" alt="The Majic Realm" className="contact-hero-logo" />
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p className="contact-text">
              For all of your support needs please contact us at{' '}
              <a href="mailto:support@majicrealm.com" className="contact-email">
                support@majicrealm.com
              </a>
            </p>
            <div className="contact-address">
              <p className="address-label">Our address:</p>
              <p className="address-line">Lemon Drop Games</p>
              <p className="address-line">15790 Redmond Way #1099</p>
              <p className="address-line">Redmond, WA 98052</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
